import React from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  extraclass?: string
  ref?: React.Ref<HTMLDivElement>
}

const MainBlock = ({ children, ...props }: Props) => {
  return (
    <div ref={props.ref} className={'animate bg-white border rounded-xl w-full p-2 md:p-4 ' + (props.extraclass || '')} {...props}>
      {children}
    </div>
  )
}

export default MainBlock